module.exports = __webpack_public_path__ + "static/media/iconfinder_Cancel__Red_34208.43d68c3b.png";